{
    "locale": "de-DE",
    "error": {
        "unsupportedMethod": "Unsupported method: {method}"
    },
    "account": {
        "deleteTokenTooltip": "Token unwiderruflich löschen?",
        "deleteToken": "Token löschen",
        "apiAccountToken": "API Account Token",
        "createApiToken": "Erstellen Sie einen neuen API Account Token",
        "createToken": "Token erstellen",
        "existingTokens": "Bestehende Tokens",
        "noApiTokensCreated": "Es wurden noch keine API Account Tokens erstellt.",
        "description": "Beschreibung",
        "createdOn": "Erstellt am",
        "token": "Token",
        "saveTokenWarning": "Speichern Sie diesen Token sorgfältig, er kann nicht noch einmal angezeigt werden.",
        "hint": "Hinweis",
        "tokenCopiedNotification": "Token wurde in die Zwischenablage kopiert.",
        "registrationNotice": "Bitte beachten Sie, dass eine eInfo-Registrierung nur als bereits gelisteter Händler funktioniert.",
        "registrationDescription": "Mit der Registrierung hier erhalten Sie nicht nur die Login-Möglichkeit für unseren Shop, sondern natürlich auch Zugang zu unserer Wissensplattform eInfo:",
        "informationAvailableTitle": "Jederzeit und überall Informationen verfügbar",
        "statusQuery": "Statusabfrage von Angeboten und Aufträgen",
        "downloadDocuments": "Download von Angebot, Auftragsbestätigung und Rechnung",
        "downloadImages": "Herunterladen von 2D und 3D-Bild, sowie DXF-Datei",
        "tracking": "Sendungsverfolgung",
        "customerLink": "Per Link Kunden und Verarbeiter über Stati informieren",
        "recognizeChargeable": "Vergütungsfähige Vorgänge direkt erkennen",
        "viewInvoices": "Versendete Rechnungen im Auftrag einsehen",
        "andMore": "Uvm.",
        "oneClickSolutionTitle": "Mit nur einem Klick zur Lösung",
        "inquiryExample": "Rückfrage stellen (z.B. bei Angebotsänderung)",
        "requestManual": "Anforderung Montageanleitung",
        "registerNow": "Jetzt kostenlos anmelden:",
        "requestAccess": "Zugang anfragen",
        "companyData": "Unternehmensdaten",
        "customerNumber": "Kundennummer",
        "company": "Firma",
        "streetAndHouseNumber": "Strasse und Hausnummer",
        "postcode": "PLZ",
        "city": "Stadt",
        "country": "Land",
        "personalAccess": "persönlicher Zugang",
        "salutation": "Anrede",
        "firstName": "Vorname",
        "lastName": "Name",
        "position": "Funktion",
        "email": "E-Mail",
        "phone": "Telefon",
        "mobilePhone": "Mobiltelefon",
        "fax": "Fax",
        "user": "Benutzer",
        "termsAcceptance": "Ich habe die",
        "termsAndConditions": "Nutzungsbedingungen",
        "privacyPolicy": "Datenschutzerklärung",
        "submitRequest": "Anfrage absenden",
        "acknowledged": "zur Kenntnis genommen und akzeptiert",
        "requestForwarded": "Die Anfrage wurde weitergeleitet.",
        "resetPassword": "Passwort zurücksetzen",
        "passwordMismatch": "Das Passwort und die Wiederholung stimmen nicht überein!",
        "passwordComplexity": "Die Passwortkomplexität ist nicht ausreichend. Bitte verwenden Sie eine Kombination Buchstaben (Groß- und Kleinschreibung), Zahlen und Sonderzeichen mit einer Mindestlänge von 8 Zeichen.",
        "passwordSetSuccess": "Ihr Passwort wurde gesetzt. Sie können sich jetzt mit Ihren Zugangsdaten einloggen.",
        "passwordChangeSuccess": "Ihr Passwort wurde geändert.",
        "errorOccurred": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
        "passwordResetLinkSent": "Falls zum angegebenen Benutzernamen ein Zugang existiert, wurde an die hinterlegte Email-Adresse ein Link zum Zurücksetzen des Passworts versendet.",
        "setPasswordTitle": "Passwort vergeben",
        "setPasswordDescription": "Legen Sie selbst ein neues Passwort für Ihren neuen Zugang fest. Sie können sich danach sofort mit Ihrem Benutzernamen und dem hier vergebenen Passwort einloggen.",
        "changePasswordTitle": "Passwort ändern",
        "newPasswordPlaceholder": "neues Passwort",
        "repeatPasswordPlaceholder": "Passwort wiederholen",
        "termsAndConditionsRead1": "Ich habe die",
        "termsAndConditionsRead2": "zur Kenntnis genommen und akzeptiert",
        "submitButton": "absenden",
        "accessDenied": "Zugriff verweigert!",
        "closeInfo": "Ihre Änderungswünsche werden geprüft.",
        "unlockColleague": "Kollegen freischalten",
        "sendChanges": "Änderungswünsche absenden",
        "firstname": "Vorname",
        "lastname": "Name",
        "submitChangeRequest": "Änderungswünsche absenden",
        "accessNumber": "Zugangsnummer",
        "changeRequestInProgress": "Ihre Änderungswünsche werden geprüft.",
        "iAccept": "Ich habe die",
        "haveRead": "zur Kenntnis genommen",
        "request": "anfragen",
        "customerBase": "Kundenbasis",
        "documentationHTML": "<h2>Dokumentation</h2><p>Wie Sie die API benutzen können, finden Sie in unserer <a href=\"{frontendBase}/tibi-api/_/{namespace}/_/assets/redoc/\" target=\"_blank\">API-Dokumentation</a>.</p><p>Die API ist eine REST-API, die Sie mit jedem HTTP-Client ansprechen können.</p><p>Für die Authentifizierung müssen Sie den generierten Token in den HTTP-Header \"account-token-v1\" einfügen.</p><h3>Beispiel</h3><p><code>curl 'https://einfo.renzgroup.com/api/operation?limit=10&offset=0&sort=-insertTime'<br />&nbsp; -H \"accept: application/json\"<br />&nbsp; -H \"account-token-v1: TOKEN\"</code></p>"
    },
    "header": {
        "watchlist": "Merkliste",
        "processInformationSystem": "Vorgangsinformationssystem",
        "switchAccount": "Account wechseln",
        "changeMasterData": "Stammdaten ändern",
        "changePassword": "Passwort ändern",
        "template": "Vorlage",
        "priceCalculation": "Preiskalkulation",
        "addressBook": "Adressbuch",
        "integrations": "Integrationen",
        "token": "Token",
        "logout": "Abmelden",
        "login": "Anmelden",
        "more": "Mehr",
        "copyrightPage": "Impressum",
        "logoutIn": "logout in {logoutInMinutes} min"
    },
    "notifications": {
        "successfulLogout": "Sie wurden erfolgreich vom System abgemeldet.",
        "failedLogout": "Bei Ihrer Anmeldung ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre Zugangsdaten.",
        "resubmissionSuccessfullyUpdated": "Wiedervorlage erfolgreich aktuallisiert.",
        "resubmissionSuccessfullyCreated": "Wiedervorlage erfolgreich erstellt.",
        "changesGotSaved": "Die Änderungen wurden erfolgreich aktualisiert."
    },
    "cart": {
        "cancel": "Abbrechen",
        "moveToCart": "In Warenkorb verschieben",
        "move": "Verschieben",
        "referenceOfferNotFound": "Referenzangebot nicht gefunden",
        "mapping": {
            "refNumber": "Referenznummer",
            "number": "Nummer",
            "endCustomerEmail": "Endkunde E-Mail",
            "endCustomerPhone": "Endkunde Telefon",
            "endCustomerAddress": {
                "label": "Endkunde Adresse",
                "name1": "Name 1",
                "name2": "Name 2",
                "name3": "Name 3",
                "street": "Straße",
                "country": "Land",
                "postcode": "PLZ",
                "city": "Ort"
            },
            "endCustomerVAT": "Endkunde MwSt.",
            "sumEndCustomerPrice": "Endkundenpreis",
            "sumEndCustomerPriceGross": "Endkundenpreis inkl. MwSt.",
            "type": {
                "label": "Typ",
                "1": "Angebot",
                "2": "Auftrag"
            },
            "source": {
                "label": "Herkunft",
                "10": "Back Office",
                "20": "eConfig Pro (RIK)",
                "30": "eConfig (VR)",
                "31": "eAssist",
                "40": "RIT",
                "50": "eShop",
                "60": "eInfo",
                "80": "VU verbundene Unternehmen",
                "90": "LIK"
            },
            "statusSummary": {
                "label": "Statuszusammenfassung",
                "created": {
                    "label": "Angelegt",
                    "0": "nein",
                    "30": "in Bearbeitung",
                    "100": "abgeschlossen"
                },
                "emailed": {
                    "label": "Versendet",
                    "0": "nein",
                    "100": "ja"
                }
            },
            "orderedSummary": {
                "label": "Bestellzusammenfassung",
                "ordered": {
                    "label": "Bestellt",
                    "0": "nein",
                    "100": "ja"
                },
                "orderedCount": "Anzahl bestellt"
            },
            "endCustomerFullAddress": {
                "label": "Endkunde Vollständige Adresse",
                "id": "ID",
                "insertTime": "Einfügezeit",
                "updateTime": "Aktualisierungszeit",
                "dealerNumber": "Händlernummer",
                "type": {
                    "label": "Typ",
                    "person": "Person",
                    "company": "Unternehmen"
                },
                "vat": "MwSt.",
                "company": {
                    "label": "Unternehmen",
                    "name": "Name",
                    "vatId": "MwSt. ID",
                    "firstname": "Vorname",
                    "lastname": "Nachname",
                    "paymentTerms": "Zahlungsbedingungen"
                },
                "person": {
                    "label": "Person",
                    "salutation": "Anrede",
                    "firstname": "Vorname",
                    "lastname": "Nachname",
                    "parentCompany": "Muttergesellschaft"
                },
                "location": {
                    "label": "Standort",
                    "street": "Straße",
                    "houseNumber": "Hausnummer",
                    "supplement": "Ergänzung",
                    "postcode": "PLZ",
                    "city": "Ort",
                    "country": "Land"
                },
                "contact": {
                    "label": "Kontakt",
                    "phone": "Telefon",
                    "fax": "Fax",
                    "email": "E-Mail",
                    "website": "Webseite"
                },
                "customerNumber": "Kundennummer",
                "priceCalculation": "Preisberechnung",
                "notModifyablePCalc": "Unveränderliche Preisberechnung",
                "deliveryAddress": {
                    "label": "Lieferadresse",
                    "salutation": "Anrede",
                    "name1": "Name 1",
                    "name2": "Name 2",
                    "name3": "Name 3",
                    "street": "Straße",
                    "country": "Land",
                    "postcode": "PLZ",
                    "city": "Ort",
                    "phone": "Telefon",
                    "fax": "Fax",
                    "email": "E-Mail"
                }
            },
            "dealerNumber": "Händlernummer",
            "inquiryDate": "Anfragedatum",
            "inquiryNumber": "Anfragenummer",
            "receiptDate": "Eingangsdatum",
            "releaseDate": "Freigabedatum",
            "constructionProject": "Bauvorhaben",
            "constructionSite": "Bauort",
            "commission": "Kommission",
            "residentialUnitsCount": "Anzahl der WE",
            "deliveryAddress": {
                "label": "Lieferadresse",
                "salutation": "Anrede",
                "name1": "Name 1",
                "name2": "Name 2",
                "name3": "Name 3",
                "street": "Straße",
                "country": "Land",
                "postcode": "PLZ",
                "city": "Ort",
                "phone": "Telefon",
                "fax": "Fax",
                "email": "E-Mail"
            },
            "inquiryContact": {
                "label": "Sachbearbeiter / Besteller",
                "name": "Name"
            },
            "endCustomer": {
                "label": "Endkunde",
                "name": "Name"
            },
            "sumNetPrice": "Nettowarenwert",
            "sumRetailPrice": "UVP",
            "clerk": {
                "label": "Sachbearbeiter",
                "name": "Name",
                "email": "E-Mail"
            },
            "internalClerk": {
                "label": "interner Sachbearbeiter",
                "name": "Name"
            },
            "additionalPositions": {
                "label": "Zusatzpositionen",
                "number": "Nummer",
                "service": "Dienstleistung",
                "description": "Beschreibung",
                "netPrice": "Nettopreis",
                "amount": "Menge"
            },
            "documentTemplateTextContent": {
                "label": "Dokumentvorlage Textinhalt",
                "emailSubject": "E-Mail Betreff",
                "emailBody": "E-Mail Text",
                "pdfIntro": "PDF Einleitung",
                "pdfOutro": "PDF Schluss",
                "preLetter": "Voranschreiben",
                "deliveryTime": "Lieferzeit",
                "paymentTerms": "Zahlungsbedingungen",
                "contact": {
                    "label": "Kontakt",
                    "useLoggedInUserAsDefault": "Verwende eingeloggten Benutzer als Standard",
                    "name": "Name",
                    "phone": "Telefon",
                    "email": "E-Mail",
                    "webUrl": "Webseite"
                }
            },
            "positions": {
                "label": "Positionen",
                "number": "Nummer",
                "type": "Art",
                "quantity": "Anzahl",
                "orderQuantity": "Anzahl in Bestellung",
                "color": {
                    "label": "Farbe",
                    "code": "Farbcode",
                    "name": "Farbname"
                },
                "additionalItems": {
                    "label": "Zusatzartikel",
                    "number": "Nummer",
                    "description": "Beschreibung",
                    "netPrice": "Nettopreis",
                    "service": "Dienstleistung",
                    "amount": "Menge"
                },
                "state": {
                    "label": "Status",
                    "code": "Code",
                    "description": "Beschreibung",
                    "blockingIndicator": "Sperrkennzeichen"
                },
                "delivery": {
                    "label": "Lieferung",
                    "plannedDate": "geplantes Datum",
                    "plannedDateNew": "neues geplantes Datum",
                    "plannedWeek": "geplante Woche",
                    "actualDate": "tatsächliches Datum",
                    "shippingCompany": "Versandunternehmen Code"
                },
                "origin": {
                    "label": "Ursprung",
                    "operationNumber": "Vorgangsnummer",
                    "positionNumber": "Positionsnummer"
                },
                "residentialUnitsCount": "Anzahl der WE",
                "residentialUnitsCountTotal": "Anzahl der WE gesamt",
                "rikNumber": "ECP Nummer",
                "productGroup": "Produktgruppe",
                "modelGroup": "Modellgruppe",
                "installationType": "Einbauart",
                "netPrice": "Nettopreis",
                "endCustomerPrice": "Endkunden-Preis",
                "endCustomerPriceGross": "Endkundenpreis inkl. MwSt.",
                "retailPrice": "UVP",
                "alternativeTo": "Alternative zu",
                "objectionPeriodEnd": "Enddatum der Einspruchsfrist",
                "instructionsAvailable": "Montageanleitung abrufbar",
                "specialCAD": "Sonder-CAD",
                "items": {
                    "label": "Positionselemente",
                    "sequenceNumber": "laufende Nummer",
                    "amount": "Menge",
                    "measureUnit": "Mengeneinheit",
                    "number": "Bestellnummer",
                    "description": "Bezeichnung"
                },
                "tracking": {
                    "label": "Tracking",
                    "sequenceNumber": "laufende Nummer",
                    "trackingNumber": "Trackingnummer",
                    "status": "Status",
                    "receiver": "Empfänger"
                },
                "chargeable": "vergütungsfähig",
                "chargeableReason": "vergütungsfähig - Grund"
            }
        },
        "updated": "Warenkorb {name} wurde aktualisiert.",
        "updateFailedS": "Warenkorb {name} konnte nicht aktualisiert werden!",
        "inCartTooltip": "Dieses Angebot befindet sich in den folgenden Warenkörben:",
        "addToCartTooltip": "Zum Warenkorb hinzufügen",
        "dataTakeover": "Daten aus dem Angebot übernehmen:",
        "dataOvertake": "Datenübernahme",
        "missingRequiredFields": "Bitte füllen Sie alle Pflichtfelder aus!",
        "noDataAvailable": "Für diese Position stehen keine Daten zur Übernahme bereit.",
        "moveOffer": "Angebot in anderen Warenkorb verschieben",
        "moveOfferDisabled": "Angebot kann nicht in anderen Warenkorb verschoben werden, da kein anderer Warenkorb existiert.",
        "copyOffer": "Angebot in anderen Warenkorb kopieren",
        "copyOfferDisabled": "Angebot kann nicht in anderen Warenkorb kopiert werden, da kein anderer Warenkorb existiert.",
        "deleteOffer": "Angebot aus Warenkorb löschen",
        "moveOfferS": "Angebot verschieben",
        "deliveryAddress": "Lieferanschrift",
        "created": "Warenkorb {name} wurde erstellt.",
        "createFailed": "Warenkorb {name} konnte nicht erstellt werden!",
        "cart": "Warenkorb",
        "carts": "Warenkörbe",
        "copyOfferS": "Angebot kopieren",
        "phoneNotificationChosen": "Die telefonische Avisierung wurde gewählt. Bitte füllen Sie die Felder für die telefonische Avisierung.",
        "cartDeleted": "Warenkorb wurde gelöscht.",
        "cartDeleteFailed": "Warenkorb konnte nicht gelöscht werden!",
        "orderSent": "Bestellung wurde versandt.",
        "back": "Zurück",
        "addressUpdated": "Adresse wurde aktualisiert.",
        "addressUpdateFailed": "Adresse konnte nicht aktualisiert werden, überprüfen sie die Eingabe!",
        "addressCreated": "Adresse wurde im Adressbuch angelegt.",
        "addressCreateFailed": "Adresse konnte nicht im Adressbuch angelegt werden, überprüfen sie die Eingabe!",
        "orderFailed": "Bestellung konnte nicht versandt werden!",
        "updateFailed": "Warenkorb konnte nicht aktualisiert werden!",
        "costNotice": "Bitte beachten Sie künftig entstehende Kosten. Im Moment fallen noch keine Kosten an.",
        "phoneNotificationRequested": "telefonische Avisierung erwünscht?",
        "phoneNotification": "Avis-Telefon",
        "editCart": "Warenkorb bearbeiten",
        "deleteCart": "Warenkorb löschen",
        "cartIcon": {
            "inCartTooltip": "Dieses Angebot befindet sich in den folgenden Warenkörben: {foundInCarts}",
            "addMarkedItemsTooltip": "Alle markierten Positionen in den Warenkorb legen",
            "addAllItemsTooltip": "Alle Positionen in den Warenkorb legen."
        },
        "updateSuccess": "Name des Warenkorbs wurde geändert.",
        "updateError": "Name des Warenkorbs konnte nicht geändert werden!",
        "createSuccess": "Neuer Warenkorb wurde erstellt.",
        "createError": "Neuer Warenkorb konnte nicht erstellt werden!",
        "createNewCartName": "Neuer Warenkorb",
        "addCart": "Warenkorb hinzufügen",
        "createSuccessNotification": "Der Warenkorb wurde erfolgreich angelegt.",
        "deleteSuccessNotification": "Der Warenkorb wurde erfolgreich gelöscht.",
        "updateSuccessNotification": "Der Warenkorb wurde aktualisiert.",
        "updateErrorNotification": "Der Warenkorb konnte nicht aktualisiert werden.",
        "noCartsCreated": "Aktuell wurden noch keine Warenkörbe erstellt.",
        "deleteModalTitle": "Warenkorb löschen",
        "deleteModalMessage": "Soll der Warenkorb <strong>{cartName}</strong> wirklich gelöscht werden?",
        "deleteButton": "Warenkorb löschen",
        "total": "Gesamt",
        "amountPos": "Anz. Pos.",
        "totalSum": "Gesamtsumme",
        "sendOrder": "Bestellung absenden",
        "saveData": "Daten gespeichert",
        "lookInAddressBook": "Im Adressbuch suchen",
        "deviatingShippingAddress": "abweichende Lieferanschrift",
        "homeAddress": "Heimatadresse",
        "shippingAddress": "Lieferanschrift",
        "commission": "Kommission",
        "commissionPlaceholder": "Kommission eintragen",
        "constructionProject": "Bauvorhaben",
        "constructionProjectPlaceholder": "Bauvorhaben eintragen",
        "shipment": {
            "selectCalendarWeek": "Kalenderwoche auswählen",
            "dontShipBefore": "Lieferung bitte nicht vor KW:"
        },
        "legend": {
            "legend": "Legende",
            "operationCreated": "Vorgang angelegt",
            "inProgress": "in Bearbeitung",
            "offerCreated": "Angebot erstellt",
            "mandatoryField": "Pflichtfeld"
        },
        "modals": {
            "copy": "Kopieren",
            "confirmDataTakeover": {
                "header": "Daten übernehmen",
                "body": "Sollen die Daten aus dem Angebot {number} in den aktuellen Warenkorb übernommen werden?",
                "cancel": "Abbrechen",
                "confirm": "Daten Übernehmen"
            },
            "deleteCartOperation": {
                "header": "Aus dem Warenkorb löschen",
                "body": "Möchten Sie das Angebot {number} wirklich aus dem Warenkorb löschen?",
                "cancel": "Abbrechen",
                "confirm": "Löschen"
            },
            "addressUpdate": {
                "headerCreate": "Adresse erstellen",
                "headerUpdate": "Adresse aktualisieren",
                "bodyCreate": "Möchten Sie die Adresse wirklich erstellen?",
                "bodyUpdate": "Möchten Sie die Adresse wirklich aktualisieren?",
                "cancel": "Abbrechen",
                "confirmCreate": "Erstellen",
                "confirmUpdate": "Aktualisieren"
            },
            "moveCartOperation": "Angebot in anderen Warenkorb verschieben",
            "copyCartOperation": "Angebot in Warenkörbe kopieren",
            "orderCart": {
                "header": "Warenkorb bestellen",
                "body": "Wollen Sie die Bestellung {name} wirklich absenden?",
                "cancel": "Abbrechen",
                "confirm": "Bestellung absenden"
            },
            "cartDeletion": {
                "header": "Warenkorb löschen",
                "body": "Der Warenkorb ist leer. Möchten Sie den Warenkorb {name} löschen?",
                "cancel": "Abbrechen",
                "confirm": "löschen",
                "success": "Warenkorb wurde gelöscht.",
                "error": "Warenkorb konnte nicht gelöscht werden!"
            }
        },
        "assignOperation": {
            "title": "Angebot in Warenkorb verschieben",
            "newCartLabel": "Neuer Warenkorb",
            "tooltipAddToCart": "Zum Warenkorb hinzufügen",
            "cancelButtonLabel": "Abbrechen",
            "submitButtonLabel": "Hinzufügen",
            "invalidCartNameTooltip": "Invalider Warenkorbname, überprüfen Sie ob es den Namen schon gibt und das der Warenkorb einen richtigen Namen hat.",
            "noCartNameTooltip": "Bitte geben Sie einen Warenkorbnamen ein oder wählen Sie einen Warenkorb aus.",
            "selectCartTooltip": "Zum Warenkorb hinzufügen"
        }
    },
    "tableColumns": {
        "source": {
            "label": "H",
            "tooltip": "Herkunft"
        },
        "dealerNumber": {
            "label": "Kd-Nr.",
            "tooltip": "Händlernummer"
        },
        "releaseDate": {
            "label": "Angebotsdatum"
        },
        "insertTimeOut1": {
            "label": "Angebotsdatum"
        },
        "insertTimeOut2": {
            "label": "ABdatum"
        },
        "number": {
            "labelOffer": "Angebotsnr.",
            "labelOrder": "Auftragsnr."
        },
        "countOfPositions": {
            "label": "Anz.Pos.",
            "tooltip": "Anzahl der Positionen"
        },
        "status": {
            "label": "Status"
        },
        "canceled": {
            "label": "Storno"
        },
        "chargeable": {
            "label": "Vergütungsfähig",
            "tooltip": "Vergütungsfähig",
            "labelShort": "V"
        },
        "inquiryDate": {
            "label": "Anfragedatum"
        },
        "releaseDateOrder": {
            "label": "Bestelldatum"
        },
        "endCustomerName": {
            "label": "Anfrage/Name"
        },
        "inquiryNumber": {
            "labelInquiry": "Anfragenr.",
            "labelOrder": "Bestellnr."
        },
        "constructionProject": {
            "label": "Bauvorhaben"
        },
        "commission": {
            "label": "Kommission"
        },
        "constructionSite": {
            "label": "Bauort"
        },
        "inquiryContact": {
            "label": "Sachbearbeiter"
        },
        "lastUpdatedBy": {
            "label": "Zuletzt Bearbeitet von"
        },
        "deliveryAddress": {
            "label": "Lieferadresse",
            "noDeliveryAddress": "Keine Lieferadresse"
        },
        "endCustomerFullAddress": {
            "label": "Endkunde - Name",
            "address": "Endkundenadresse"
        },
        "residentialUnitsCount": {
            "label": "WE",
            "tooltip": "Wohneinheiten"
        },
        "sumNetPrice": {
            "label": "Summe"
        },
        "followUpListOwner": {
            "label": "Merklistenbesitzer"
        },
        "description": {
            "label": "Beschreibung"
        },
        "insertTime": {
            "label": "Erstellt am"
        },
        "lastUsed": {
            "label": "letzte Verwendung"
        }
    },
    "bookmarks": {
        "icon": {
            "editOwnResubmissionsOnly": "Sie können nur Ihre eigenen Wiedervorlagen bearbeiten.",
            "removeFromWatchlist": "von Merkliste entfernen",
            "addToWatchlist": "zur Merkliste hinzufügen"
        },
        "addBookmarks": "Lesezeichen hinzufügen",
        "addedBookmarks": "Lesezeichen hinzugefügt",
        "removeBookmarks": "Lesezeichen entfernen",
        "removedBookmarks": "Lesezeichen entfernt",
        "offers": "Angebote",
        "orders": "Aufträge",
        "outgoingOffers": "Ausgangsangebote",
        "orderConfirmations": "Auftragsbestätigungen",
        "bookmarks": "Merkliste",
        "myBookmarks": "Meine Merkliste",
        "fullTextSearch": "Volltextsuche",
        "resetFilter": "Filter zurücksetzen"
    },
    "login": {
        "successNotification": "Sie wurden erfolgreich am eInfo-System angemeldet.",
        "failNotification": "Bei Ihrer Anmeldung ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre Zugangsdaten.",
        "mfaNotification": "Ihre Anmeldung benötigt eine zusätzliche Bestätigung. Bitte geben Sie den Code ein, den Sie per E-Mail erhalten haben.",
        "unknownErrorNotification": "Unbekannter Fehler bei der Anmeldung.",
        "enterMfaCode": "Bitte geben Sie den Code ein, der Ihnen per E-Mail zugesandt wurde.",
        "usernamePlaceholder": "Benutzer",
        "passwordPlaceholder": "Passwort",
        "submitButton": "absenden",
        "resetPassword": "Passwort zurücksetzen",
        "requestAccess": "Zugang anfragen",
        "login": "Anmelden",
        "code": "Code"
    },
    "integrations": {
        "configIntegrations": "Konfigurator-Integration",
        "iframeRecommendation": "Wir empfehlen für die Einbindung des iFrames eine Mindesthöhe von <b>800px</b> bei einer Mindestbreite von <b>1000px</b>.",
        "contactDataPrepopulation": "Vorbelegung der Kontaktdaten (optional)",
        "useCustomerData": "Sie haben die Möglichkeit mit den Stammdaten Ihrer eingeloggten Kunden den Konfigurator vorzubelegen.",
        "fieldsToPrepopulate": "Folgende Felder können vorbelegt werden und über die Feldnamen in der URL angehangen werden:",
        "dealerErrorHeader": "Der Händler mit der Nummer {dealerNumbers} ist nicht vollständig für die Verwendung im Konfigurator konfiguriert!",
        "dealerErrorInstructions": "Bitte prüfen Sie, ob im Händler-Account die Angebotsvorlage korrekt eingerichtet ist und für die Verwendung freigeschaltet wurde.",
        "preDefInsert": "Vorbelegung im Code {additionalInfo} einfügen",
        "iframePreview": "und iFrame-Vorschau",
        "colorStyle": "Farbstil",
        "selectColorStyle": "Farbstil auswählen",
        "backgroundColor": "Hintergrundfarbe (Optional)",
        "dealerCustomer": "Händlerkunde",
        "dealerCustomers": "Händlerkunden",
        "enterNumberOrName": "Nummer / Name eingeben",
        "sourceCode": "Quellcode für Ihre Website",
        "preview": "Vorschau",
        "fieldName": "Feldname",
        "importance": "Bedeutung",
        "example": "Beispiel",
        "noEntriesFound": "Keine Einträge gefunden",
        "dealerIsntAvailable": "Der Händler ist nicht für die Verwendung im Konfigurator konfiguriert oder freigeschaltet.",
        "integrationsMap": {
            "firstname": "Vorname",
            "lastname": "Nachname",
            "company": "Unternehmen",
            "city": "Ort",
            "street": "Straße",
            "houseNumber": "Hausnummer",
            "postcode": "PLZ",
            "countryCode": "Ländercode",
            "email": "E-Mail",
            "phone": "Telefon"
        }
    },
    "operationsLegend": {
        "legendTitle": "Legende",
        "createdOperation": "Vorgang angelegt",
        "inProgress": "in Bearbeitung",
        "offerCreated": "Angebot erstellt",
        "cancellation": "Storno",
        "partialCancellation": "Teilstorno",
        "statusDescriptionTitle": "Status-Beschreibung",
        "notStarted": "nicht begonnen",
        "inProcess": "im Prozess",
        "delayed": "im Verzug",
        "partlyDone": "zum Teil erledigt",
        "completed": "erledigt",
        "orderConfirmation": "Auftrags-Bestätigung",
        "objectionPeriod": "Einspruchsfrist",
        "manufacture": "Fertigung",
        "shipping": "Versand",
        "delivery": "Lieferung"
    },
    "followUp": {
        "onMyList": "auf meiner Liste",
        "ownAndForeign": "Sie haben {total} überfällige Wiedervorlage{plural}. Davon {ownCount} eigene und {foreignCount} fremde.",
        "onlyOwn": "Sie haben {total} überfällige Wiedervorlage{plural}.",
        "added": "Wiedervorlage hinzugefügt",
        "removed": "Wiedervorlage entfernt"
    },
    "operations": {
        "shareTransaction": "Diesen Vorgang via Link teilen",
        "inquiryS": "Rückfrage zu {opNumber}",
        "inquiryContact": "Sachbearbeiter",
        "protocol": "Protokoll zu {opNumber}",
        "email": "Mail zu {opNumber}",
        "offerType1": "{offerTabTitle_Type1} {opNumber}",
        "orderConfirmation": "Auftragsbestätigung {opNumber}",
        "orderS": "Auftrag {opNumber}",
        "offerT": "Angebot",
        "offer": "Rückfrage zum gesamten Angebot stellen",
        "linkSent": "Der Link wurde erfolgreich an '{email}' versandt.",
        "invalidEmail": "'{email}' ist keine gültige E-Mail-Adresse.",
        "showPositionDetails": "Positionsdetails anzeigen.",
        "incompleteOperation": "Dieser Vorgang ist noch nicht vollständig erstellt.",
        "linkRegenerated": "Der Link wurde neu generiert. Der alte Link verliert somit seine Gültigkeit.",
        "linkDeactivated": "Der Link wurde deaktiviert.",
        "linkCopied": "Der Link wurde in die Zwischenablage kopiert.",
        "linkCopyFailed": "Der Link konnte nicht in die Zwischenablage kopiert werden. {text}",
        "order": "Auftrag",
        "share": "teilen",
        "linkDescription": "Über einen Link können andere Personen (z.B. Kunden) diesen Vorgang anschauen.",
        "noPriceInfo": "Für die anderen Personen sind beim Aufruf des Links keine Preise bzw. Konditionen ersichtlich.",
        "copyLinkHint": "Hier können Sie den Link in die Zwischenablage kopieren und manuell weiterleiten.",
        "copyLink": "Link kopieren",
        "regenerateLink": "Link neu generieren",
        "regenerateLinkTooltip": "Durch das Generieren eines neuen Links\nverliert der aktuell erzeugte Link seine Gültigkeit.",
        "deactivateLink": "Link deaktivieren",
        "deactivateLinkTooltip": "Durch das Deaktivieren verliert der aktuell erzeugte Link seine Gültigkeit.\nDer Empfänger des Links kann nicht mehr auf den Vorgang zugreifen.",
        "sendLinkByEmail": "Link per E-Mail senden",
        "enterEmailHint": "Geben Sie die gewünschte Empfänger Mailadresse ein und klicken Sie auf Senden.",
        "emailPlaceholder": "E-Mail Empfänger eintragen",
        "resetChanges": "Hiermit setzen Sie alle Änderungen zur letzten Speicherung zurück.",
        "inquiryTitle": "Rückfrage zu",
        "generalInquiry": "Allgemeine Rückfrage",
        "complaint": "Reklamation",
        "other": "Sonstiges",
        "inquirySent": "Ihre Anfrage wurde versendet.",
        "operationNumber": "Vorgang {number}",
        "operationNotFound": "Vorgang {number} wurde nicht gefunden.",
        "shareLinkInvalid": "Dieser Link ist nicht mehr gültig. Der Vorgang wurde gelöscht oder der Zugriff wurde widerrufen. Bitte fragen Sie die Person, die den Link geschickt hat, nach einem neuen.",
        "position": "Position",
        "topic": "Thema",
        "selectTopic": "Thema auswählen",
        "message": "Nachricht",
        "submit": "absenden",
        "source": "Herkunft",
        "customerNumber": "Kd-Nr.",
        "orderNumber": "Auftragsnr.",
        "outbound": "Ausgang",
        "origin": "Ursprung",
        "numberOfPositions": "Anz. Pos.",
        "status": "Status",
        "cancellation": "Storno",
        "orderDate": "Bestelldatum",
        "endCustomer": "Endkunde",
        "inquiryName": "Anfrage/Name",
        "inquiryNumber": "Anfragenr.",
        "constructionProject": "Bauvorhaben",
        "commission": "Kommission",
        "constructionSite": "Bauort",
        "orderContact": "Besteller",
        "we": "WE",
        "residentialUnits": "Wohneinheiten",
        "sum": "Summe",
        "inquiry": "Rückfrage",
        "inquiryPlace": "Rückfrage stellen",
        "inquiryOrder": "Rückfrage zum gesamten Auftrag stellen",
        "deliveryAddress": "Lieferanschrift",
        "lastUpdatedBy": "Zuletzt bearbeitet von",
        "openCustomerOrderConfirmation": "Kundenauftragsbestätigung öffnen",
        "openOriginalOrder": "Ursprünglichen Auftrag öffnen",
        "offerDate": "Angebotsdatum",
        "offerNumber": "Angebotsnr.",
        "openCustomerOffer": "Kundenangebot öffnen",
        "openOriginalOffer": "Ursprüngliches Angebot öffnen",
        "inquiryDate": "Anfragedatum",
        "duplicateAndEdit": "Duplizieren <br/> und bearbeiten",
        "head": {
            "origin": "Herkunft",
            "customerNumber": "Kd-Nr.",
            "offerDate": "Angebotsdatum",
            "orderConfirmationDate": "Auftrags-<br/> bestätigungsdatum",
            "offerNr": "Angebotsnr.",
            "orderNr": "Auftragsnr.",
            "source": "Ursprung",
            "openOriginalOffer": "Ursprüngliches Angebot öffnen",
            "openOriginalOrder": "Ursprünglichen Auftrag öffnen",
            "initialOffer": "Ausgangsangebot",
            "noReferenceFound": "Keine Referenz gefunden",
            "amountOfPositions": "Anz. Pos.",
            "status": "Status",
            "inquiryDate": "Anfragedatum",
            "editedLast": "Zuletzt bearbeitet <br /> von",
            "clerk": "Sachbearbeiter",
            "yourReference": "Ihre Referenz",
            "constructionProject": "Bauvorhaben",
            "commission": "Kommission"
        }
    },
    "operationsOut": {
        "entryNotFound": "Der Eintrag wurde nicht gefunden.",
        "clickForMoreInfo": "Eintrag anklicken, für mehr Infos",
        "resetFilter": "Filter zurücksetzen",
        "filter": "Filter",
        "tableView": "Tabellendarstellung",
        "gridView": "Rasterdarstellung",
        "orderConfirmation": "Auftragsbestätigung",
        "address": {
            "applyPriceGroup": "Preisgruppe anwenden?",
            "noPriceGroup": "Die Adresse hat keine Preisgruppe hinterlegt.",
            "resetGlobal": "Möchten Sie die Preiskalkulation auf die globale Einstellung zurücksetzen?",
            "partnerCompany": "Die Firma des Ansprechpartners",
            "selectedAddress": "Ihre ausgewählte Adresse",
            "priceGroupApplied": "hat die Preisgruppe {priceGroup} hinterlegt, möchten Sie diese auf {documentType} anwenden?",
            "currentOffer": "das aktuelle Angebot",
            "currentOrderConfirmation": "die aktuelle Auftragsbestätigung",
            "no": "nein",
            "yes": "ja",
            "endCustomerAddress": "Endkundenadresse",
            "searchInAddressBook": "Im Adressbuch suchen",
            "saveData": "Daten gespeichert"
        }
    },
    "positions": {
        "specialRequestNoCharge": "Sonderwunsch an Renz Mitarbeiter ggf. keine Vergütung mehr",
        "sequenceNumber": "Lfd.Nr.",
        "quantity": "Menge",
        "unit": "Einh.",
        "articleNumber": "Artikelnummer",
        "description": "Bezeichnung",
        "offerNumber": "Angebotsnr.",
        "orderNumber": "Auftragsnr.",
        "position": "Position",
        "alternativeTo": "Alternative zu",
        "fileAttachements": "Dateianhänge",
        "linkedIncomingOperations": "Verknüpfte Eingangsvorgänge",
        "linkedOutgoingOperations": "Verknüpfte Ausgangsvorgänge",
        "texts": "Texte",
        "positionCoverLetter": "Positions-Vorbrief",
        "positionsTexts": "Positions-Texte",
        "origin": "H.",
        "source": "Ursprung",
        "customerNumber": "Kd-Nr.",
        "attachement": "Verknüpfung",
        "amountOfPositions": "Anz.Pos.",
        "status": "Status",
        "date": "Datum",
        "inquiryOrOrderNumber": "Anfrage-/Bestellnr.",
        "commission": "Kommission",
        "constructionProject": "Bauvorhaben",
        "constructionSite": "Bauort",
        "residentialUnits": "WE",
        "residentialUnitsCountTooltip": "Wohneinheiten",
        "sum": "Summe",
        "noAttachedOperations": "keine verknüpften Vorgänge",
        "net": "netto",
        "gross": "brutto",
        "withoutAlternativePositions": "ohne Alternativpositionen",
        "assemblyInstructionSent": "Die angefragte Montageanleitung erhalten Sie per E-Mail sowie ist diese auch in den nächsten Minuten im eInfo hinterlegt.",
        "errorOccurred": "Es ist ein Fehler aufgetreten! Bitte versuchen Sie es später erneut.",
        "requestAssemblyInstruction": "Montageanleitung anfragen",
        "enterEmailPrompt": "Bitte geben Sie uns eine E-Mail-Adresse, an die die Montageanleitung gesendet werden soll.",
        "sendAssemblyInstructionTo": "Montageanleitung senden an",
        "submit": "absenden",
        "requestAssemblyInstructionBreak": "Montageanleitung<br />anfragen",
        "deleteFromOperation": "Aus dem Vorgang löschen",
        "confirmDeletePosition": "Möchten Sie die Position \"<strong>{number}</strong>\" wirklich aus dem Vorgang löschen?",
        "deleteOperation": "Vorgang löschen",
        "confirmDeleteLastPosition": "Dies ist die letzte Position. Sind Sie sich sicher, dass Sie den Vorgang aus dem Warenkorb löschen möchten?",
        "restorePosition": "Position wiederherstellen",
        "confirmRestorePosition": "Möchten Sie die Position \"<strong>{number}</strong>\" wirklich wiederherstellen?",
        "marginWarning": "Ihr Abgabepreis ist geringer als Ihr Einstandspreis.",
        "image": "Bild",
        "positionShort": "Pos.",
        "quantityShort": "Anz.",
        "chargeable": "vergütungsfähig",
        "productGroup": "Produktgruppe",
        "modelGroup": "Modellgruppe",
        "color": "Farbe",
        "cancellation": "Storno",
        "noCancellation": "kein Storno",
        "deliveryDateFromFactory": "Liefertermin ab Werk",
        "tracking": "Paketverfolgung",
        "ecpNumber": "ECP-Nummer",
        "residentialUnitsShort": "WE",
        "infoToAgent": "Info an Sb.",
        "unitPrice": "Einzelpreis",
        "actions": "Aktionen",
        "packagingAndShipping": "Verpackung & Versand",
        "packagingAndShippingDescription": "Dieser Betrag wird für Verpackung und Versand berechnet.",
        "noPreviousEntry": "Kein früherer Eintrag",
        "alternativeToPosition": "Alternative zu Position {number}",
        "previousValue": "früherer Wert",
        "amount": "Anzahl",
        "sellingPrice": "VK",
        "purchasePrice": "EK",
        "showPositionDetails": "Positionsdetails anzeigen.",
        "inquiry": "Rückfrage",
        "inquiryForPosition": "Rückfrage zu dieser Position stellen",
        "deletePosition": "Position löschen",
        "delete": "löschen",
        "recreate": "Wiederherstellen",
        "recreatePosition": "Position wiederherstellen",
        "noColorSpecification": "keine Farbangabe",
        "addAdditionalService": "Zusätzliche Leistung hinzufügen",
        "RRP": "UVP",
        "endcustomer": "Endkunde",
        "margin": "Marge"
    },
    "priceCalculation": {
        "priceCalculation": "Preiskalkulation",
        "globalPricegroup": "globale Preisgruppe",
        "dealerNr": "Händer Nr.",
        "manualInput": "Manuelle Eingabe"
    },
    "address": {
        "deliveryEqualsCompany": "Lieferadresse gleich Firmenadresse",
        "deliveryUnequalsCompany": "Lieferadresse ungleich Firmenadresse",
        "customerNumberAlreadyTaken": "Kundennummer bereits vergeben.",
        "decideCompAndShipAddress": "Bitte entscheiden Sie, ob die Firmenadresse gleich der Lieferadresse ist.",
        "fillOutMandatoryFields": "Bitte füllen Sie alle Pflichtfelder aus!",
        "editAddress": "Adresse bearbeiten",
        "addPersonSuccess": "Ansprechpartner wurde hinzugefügt.",
        "addAddressSuccess": "Neue Adresse wurde erfolgreich angelegt.",
        "addPersonError": "Fehler beim anlegen vom Ansprechpartner.",
        "addAddressError": "Fehler beim Anlegen der Adresse.",
        "closeAddress": "Adresse schließen",
        "unsavedChanges": "Sie haben ungespeicherte Änderungen, sind Sie sicher, dass Sie das Formular schließen wollen?",
        "addressBook": "Adressbuch",
        "contactPerson": "Ansprechpartner",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "companyName": "Firmenname",
        "vatId": "USt-ID",
        "company2OrAdditionalAddress": "Firma 2 / Adresszusatz",
        "noChangeToGlobalTaxRate": "keine Änderung zu globalen Steuersatz",
        "postalCode": "PLZ",
        "vat": "MwSt.",
        "phone": "Telefon",
        "paymentTerms": "Zahlungsbedingungen",
        "fax": "Fax",
        "email": "E-Mail",
        "website": "Webseite",
        "contactPersonName": "ANSPRECHPARTNER (NAME, VORNAME)",
        "assignedPriceGroup": "Zugeordnete Preisgruppe",
        "contactPersonSalutation": "ANSPRECHPARTNER ANREDE",
        "edit": "Adresse bearbeiten",
        "delete": "Adresse löschen",
        "createSuccess": "Neue Adresse wurde erfolgreich angelegt.",
        "createError": "Fehler beim Anlegen der Adresse.",
        "freeSearch": "Freie Suche",
        "enterSearchTerm": "Suchbegriff eingeben",
        "type": "Typ",
        "company": "Firma",
        "salutation": "Anrede",
        "firstname": "Vorname",
        "lastname": "Nachname",
        "street": "Strasse",
        "houseNumber": "HNr",
        "supplement": "Adresszusatz",
        "postcode": "PLZ",
        "city": "Ort",
        "country": "Land",
        "customerNumber": "Knd.-Nr.",
        "typeTooltipCompany": "Firma",
        "typeTooltipContactPerson": "Ansprechpartner",
        "setNewAddress": "Neue Adresse anlegen",
        "setNewEntry": "Neuen Eintrag anlegen",
        "entry": "Eintrag",
        "editEntry": "Eintrag bearbeiten",
        "deleteContact": "Kontakt löschen",
        "saveData": "Daten gespeichert",
        "reset": "⟳ zurücksetzen",
        "notModified": "Adresse wurde nicht modifiziert.",
        "closeHeader": "Adresse schließen",
        "unsavedChangesWarning": "Sie haben ungespeicherte Änderungen, sind Sie sicher, dass Sie das Formular schließen wollen?",
        "contactDeletedSuccess": "Ansprechpartner wurde erfolgreich gelöscht.",
        "resetChangesInfo": "Hiermit setzen sie alle Änderungen zur letzten Speicherung zurück.",
        "deleteError": "Adresse konnte nicht gelöscht werden!",
        "multipleDeleteSuccess": "{successfulDeletes} Ansprechpartner und eine Adresse wurde erfolgreich gelöscht.",
        "partialDeleteError": "Einige Adressen konnten nicht gelöscht werden!",
        "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten!",
        "removeContactHeader": "Ansprechpartner entfernen",
        "deleteEntryHeader": "Eintrag löschen",
        "removeContactConfirm": "Möchten Sie den Ansprechpartner wirklich entfernen?",
        "deleteContactConfirm": "Möchten Sie den Kontakt wirklich aus dem Adressbuch löschen? Es werden auch alle zugewiesenen Ansprechpartner gelöscht.",
        "cancelButton": "abbrechen",
        "removeButton": "entfernen",
        "deleteButton": "löschen",
        "customerNumberLabel": "(Kunden Nr.: {customerNumber})",
        "dealerNumberLabel": "(Händler Nr.: {dealerNumber})",
        "dealerNr": "Händler Nr.",
        "manualEntry": "Manuelle Angabe",
        "newContact": "Neuer Ansprechpartner",
        "fillRequiredFields": "Bitte füllen Sie alle Pflichtfelder aus!"
    },
    "components": {
        "additionalServices": {
            "addService": "Zusätzliche Leistung hinzufügen",
            "deleteService": "Zusätzliche Leistung löschen",
            "amount": "Anzahl",
            "service": "Leistung",
            "description": "Beschreibung",
            "price": "Preis (€)",
            "salesPrice": "VK:",
            "serviceToPosition": "Leistung zu Position"
        },
        "additionalPosition": {
            "additionalPosition": "Zusatzposition",
            "headingInPdf": "Überschrift in PDF",
            "addAdditionalPosition": "Zusatzposition hinzufügen",
            "additionalPositionAdd": "Zusätzliche Position hinzufügen"
        },
        "operationsEmail": {
            "recipient": "Empfänger",
            "cc": "CC",
            "bcc": "BCC",
            "subject": "Betreff",
            "message": "Nachricht",
            "sendOfferSubject": "Kundenangebot {number}",
            "sendOrderConfirmationSubject": "Auftragsbestätigung {number}",
            "sendOfferMessage": "Sehr geehrte(r) \nanbei finden Sie das unverbindliche Angebot zu den angefragten Positionen.\n\nMit freundlichen Grüßen,\n{firstName} {lastName} ({email})",
            "sendOrderConfirmationMessage": "Sehr geehrte(r) \nanbei finden Sie die Auftragsbestätigung.\n\nMit freundlichen Grüßen,\n{firstName} {lastName} ({email})",
            "attachment": "Anhang",
            "sendButton": "Absenden",
            "offerSentNotification": "Das Angebot wurde versandt.",
            "orderConfirmationSentNotification": "Die Auftragsbestätigung wurde versendet.",
            "errorNotification": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
            "offerCouldNotBeSent": "Angebot konnte nicht gespeichert werden"
        },
        "operationDetails": {
            "manualPriceGroup": "Manuelle Angabe",
            "globalPriceGroup": "globale Preisgruppe",
            "dealerNumber": "Händler Nr.",
            "offerTemplate": "Angebotsvorlage",
            "orderConfirmationTemplate": "Auftragsbestätigungsvorlage",
            "couldNotBeCreated": " konnte nicht erstellt werden",
            "offer": "Angebot",
            "orderConfirmation": "Auftragsbestätigung",
            "isNotCompleted": " ist noch nicht fertig gestellt, bitte überprüfen Sie, ob Sie eine gültige Vorlage hinterlegt haben.",
            "wasSuccessfullySaved": " wurde erfolgreich gespeichert.",
            "offerCouldNotBeSaved": "Angebot konnte nicht gespeichert werden",
            "wasSuccessfullyCreated": " wurde erfolgreich erstellt.",
            "saveToGeneratePDF": "Speichern sie das Dokument, um die PDF zu generieren.",
            "selectAtLeastOnePosition": "Bitte mindestens eine Position auswählen",
            "markedPositionsToCart": "markierte Positionen in den Warenkorb",
            "convertToCustomerOffer": "in Kundenangebot",
            "convertToOrderConfirmation": "in Auftragsbestätigung",
            "transformTo": "umwandeln",
            "sendOfferToCustomer": "Angebot an <br /> Kunden senden",
            "createOrderConfirmationAndEdit": "Auftragsbestätigung erstellen <br /> und bearbeiten",
            "sendOrderConfirmationToCustomer": "Auftragsbestätigung an <br /> Kunde senden",
            "offerChanged": "Angebot wurde verändert, bitte Speichern!",
            "noCorrespondingOrder": "Kein korrespondierender Auftrag verfügbar, bitte gedulden Sie sich, bis der Auftrag im Renz System verfügbar ist!",
            "orderCanceled": "Auftrag wurde storniert.",
            "allPositionsCanceled": "Alle relevanten Positionen aus dem Auftrag wurden storniert.",
            "orderConfirmationChanged": "Auftragsbestätigung wurde verändert, bitte Speichern!",
            "orderConfirmationNotComplete": "Auftragsbestätigung ist noch nicht fertiggestellt.",
            "offerAlreadySent": "Angebot wurde bereits an Kunden gesendet",
            "orderConfirmationAlreadySent": "Auftragsbestätigung wurde bereits an Kunden gesendet",
            "orderConfirmationTemplateError": "Auftragsbestätigungsvorlage konnte nicht erstellt werden: ",
            "offerNotChanged": "Angebot wurde nicht verändert!",
            "orderConfirmationNotChanged": "Auftragsbestätigung wurde nicht verändert!",
            "offerReset": "Angebot auf zuletzt gespeicherten Stand zurücksetzen",
            "orderConfirmationReset": "Auftragsbestätigung auf zuletzt gespeicherten Stand zurücksetzen",
            "orderNotComplete": "Auftrag ist noch nicht fertig gestellt.",
            "offerNotCompleted": "Angebot ist noch nicht fertiggestellt, bitte überprüfen Sie das Vorhandensein der PDF. Sollte die PDF nicht vorhanden sein, überprüfen Sie, ob eine gültige Vorlage da ist und speichern Sie erneut!",
            "templateNotAvailable": "Weder die zum Vorgang zugehörige Dealernummer, noch Sie haben eine Vorlage hinterlegt.",
            "offerDataInherited": "Die Einstellungen von den Ursprungsangebot(en) der jeweiligen Positionen werden übernommen.",
            "invalid": "invalid",
            "dataFromIncomingOrder": "Die Daten aus dem Eingangsauftrag werden herangezogen."
        },
        "table": {
            "changesInOperations": "Vorgangsveränderungen",
            "fieldName": "Feldname",
            "previousValue": "Vorheriger Wert",
            "currentValue": "Aktueller Wert",
            "watchlist": "Merkliste",
            "offerNumber": "Angebotsnummer",
            "transationStemsFrom": "Der Vorgang stammt aus einem Ausgangsangebot",
            "offerGotChanged": "Das Angebot {offerNumber} wurde extern geändert, hier wird die überarbeitete Version angezeigt.",
            "noCurrentEntry": "Kein aktueller Eintrag",
            "noEarlierEntry": "Kein früherer Eintrag",
            "fields": {
                "attachmentField": {
                    "offer": "Angebot",
                    "orderConfirmation": "Auftragsbestätigung",
                    "invoice": "Rechnung",
                    "deliveryNote": "Lieferschein",
                    "twoDOverall": "2D-Gesamtbild",
                    "twoDDetail1": "2D-Detailausschnitt 1",
                    "twoDDetail2": "2D-Detailausschnitt 2",
                    "twoDImage": "2D-Bild",
                    "threeDImage": "3D-Bild",
                    "assemblyInstruction": "Montageanleitung",
                    "dxfFile": "DXF-Datei"
                },
                "cancellation": {
                    "none": "kein Storno",
                    "full": "alle Positionen storniert",
                    "partial": "Teilstorno"
                },
                "trackingList": {
                    "delivered": "zugestellt",
                    "inDelivery": "in Zustellung",
                    "inTransit": "auf dem Transportweg",
                    "noData": "keine Daten vorhanden",
                    "externalLink": "externer Link zu {shippingCompany}",
                    "noTrackingLink": "kein Tracking-Link verfügbar",
                    "shippingCompany": "Versandunternehmen: {shippingCompany}",
                    "receipt": "Quittung: {receiver}"
                },
                "trackingField": {
                    "trackingLabel": "Paketverfolgung",
                    "deliveredStatus": "{deliveredCount} von {count} zugestellt",
                    "showDetails": "Details anzeigen",
                    "notAvailable": "nicht verfügbar"
                },
                "status": {
                    "orderConfirmation": "Auftragsbestätigung",
                    "shipping": "Versand",
                    "manufacture": "Fertigung",
                    "offerCreated": "Angebot erstellt",
                    "offerInProgress": "Angebot in Bearbeitung",
                    "offerEmailSent": "Angebots-E-Mail {emailDetails} gesendet",
                    "noOfferEmailSent": "Noch keine Angebots-E-Mail gesendet",
                    "emailDetails": "zuletzt an {recipient} am {timestamp}",
                    "orderConfirmationEmailSent": "Auftragsbestätigungs-E-Mail {emailDetails}gesendet",
                    "noOrderConfirmationEmailSent": "noch keine Auftragsbestätigungs-E-Mail gesendet",
                    "inConfirmCount": "{count} Position(en) in Bearbeitung",
                    "orderConfirmed": "Auftrag bestätigt",
                    "orderInProgress": "Auftrag wird bearbeitet",
                    "objectionPeriod": "Einspruchsfrist",
                    "inObjectionPeriod": "{count} Position(en) innerhalb der Einspruchsfrist",
                    "objectionPeriodExpiredForSome": "Einspruchsfrist für {count} Position(en) abgelaufen",
                    "objectionPeriodExpired": "Einspruchsfrist abgelaufen",
                    "objectionPeriodAfterConfirmation": "Einspruchsfrist beginnt nach Auftragsbestätigung",
                    "inManufacture": "{count} Position(en) in der Fertigung",
                    "manufactureCompleted": "Fertigung abgeschlossen",
                    "noItemsInManufacture": "keine Position in der Fertigung",
                    "inReadyToShip": "{count} Position(en) in der Versandvorbereitung",
                    "readyToShipCompleted": "Versandvorbereitung abgeschlossen",
                    "noItemsReadyToShip": "keine Position im Versand",
                    "inShipment": "{count} Position(en) versendet",
                    "delivered": "{count} Position(en) zugestellt",
                    "noItemsInShipment": "keine Position in Auslieferung",
                    "missingTracking": "Es liegen keine (vollständigen) Trackinginformationen vor.",
                    "orderedMultiple": "Wurde {count} mal bestellt.",
                    "notOrdered": "Wurde noch nicht bestellt.",
                    "fullyOrdered": "komplett bestellt",
                    "orderedCount": "{count} Position(en) bestellt",
                    "outboundOfferCreated": "Ausgangsangebot erstellt",
                    "noOutboundOfferCreated": "kein Ausgangsangebot erstellt",
                    "orderConfirmationCreated": "Auftragsbestätigung erstellt",
                    "noOrderConfirmationCreated": "keine Auftragsbestätigung erstellt",
                    "operationStatusUpdated": "Der Status des Vorgangs {operationNumber} wurde auf {statusLabel} gesetzt und die Notiz aktualisiert.",
                    "operationStatusOnlyUpdated": "Der Status des Vorgangs {operationNumber} wurde auf {statusLabel} gesetzt.",
                    "operationNoteUpdated": "Die Notiz des Vorgangs {operationNumber} wurde aktualisiert.",
                    "operationStatusNotSaved": "Die Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
                    "noPermissionToEditStatus": "Sie haben keine Berechtigung, den Status zu bearbeiten",
                    "defaultFirstName": "Mein Vorname",
                    "defaultLastName": "Mein Nachname",
                    "operationTracking": "Vorgangsverfolgung zu {operationNumber}",
                    "status": "Status",
                    "notes": "Notizen",
                    "insertTimestampLine": "Zeitstempelzeile einfügen",
                    "noNotesAvailable": "Keine Notizen vorhanden",
                    "clickIconToMakeChanges": "Klicken Sie auf das Symbol, um Anpassungen vorzunehmen",
                    "inObjectionPeriodUntil": "Position innerhalb der Einspruchsfrist bis {date}",
                    "objectionPeriodExpiredOn": "Einspruchsfrist abgelaufen{dateInfo}",
                    "dateOn": " am {date}",
                    "positionInManufacture": "Position in der Fertigung",
                    "manufactureNotStarted": "Fertigung noch nicht begonnen",
                    "positionDelivered": "Position zugestellt",
                    "positionShippedNoTracking": "Position versendet\n\nEs liegen keine Trackinginformationen vor.",
                    "positionShipped": "Position versendet",
                    "positionNotShipped": "Position noch nicht versendet",
                    "positionReadyToShip": "Position in der Versandvorbereitung",
                    "noPositionsInShipping": "keine Positionen im Versand"
                },
                "number": {
                    "offerNumber": "Angebot / Nummer {operationNumber}",
                    "orderNumber": "Auftrag / Nummer {operationNumber}",
                    "positionNumber": "\nPosition {positionNumber}"
                },
                "chargeableField": {
                    "CAD": "Pos ist nun SonderCAD",
                    "NTF": "Pos ist NettoFix",
                    "BTF": "Pos ist BruttoFix",
                    "GNE": "Grund nicht ermittelbar",
                    "CPY": "Initialwert beim Kopiervorgang im BO (kommt nur bei Herkunft=BO vor)",
                    "SBE": "Vom SB nacherfasst (neue Position)",
                    "BNI": "Rücksprache beim RENZ ID Sachbearbeiter",
                    "BNA": "Boni auf Kopfebene ausgeschaltet => komplett nicht RIK-Vergütungsfähig",
                    "SW": "Kunde hat einen Sonderwunsch angegeben",
                    "SBO": "Nachträgliche Bearbeitung durch SB",
                    "SBA": "Nachträgliche Bearbeitung durch SB",
                    "SBR": "Entzug wegen manueller Bearbeitung der Rabatte",
                    "SHO": "eConfig-Erfassung",
                    "WVU": "Warenverkehr VU (verbundene Unternehmen)",
                    "QNR": "RIT-Bestellung, Quelle ist nicht RIK-Vergütungsfähig",
                    "chargeable": "Position ist vergütungsfähig.",
                    "notChargeable": "Position ist nicht vergütungsfähig",
                    "reason": "\n\n{reason}",
                    "notChargeableOperation": "Vorgang nicht vergütungsfähig. {reasonsText}",
                    "partiallyChargeable": "{chargeableCount} von {totalCount} Positionen sind vergütungsfähig. {reasonsText}",
                    "fullyChargeable": "Alle Positionen des Vorgangs sind vergütungsfähig"
                }
            }
        },
        "priceWizard": {
            "priceWizard": "Preiswizard",
            "showPricewizard": "Preiswizard anzeigen",
            "applyConfirmation": "Anwendungsbestätigung",
            "applyPriceGroupPrompt": "Möchten Sie die Preisgruppe auf den gesamten Vorgang oder lediglich auf diese Position anwenden?",
            "applyRestricted": "auf Position anwenden",
            "applyEntireOperation": "auf den gesamten Vorgang anwenden",
            "applyMarginWarning": "Ihr Abgabepreis ist geringer als ihr Einstandspreis. Sind Sie sicher, dass Sie fortfahren möchten?",
            "resetConfirmation": "Hiermit setzen sie alle Änderungen zur letzten Speicherung zurück.",
            "priceGroupNotModified": "Preisgruppe wurde nicht modifiziert.",
            "sellingPrice": "Verkaufspreis",
            "inputInEUR": "Angabe in EUR",
            "additionalPositionNumber": "Zusatzpos. Nr.",
            "quantity": "Anz. Pos.",
            "RRP": "UVP",
            "sale": "Rabatt",
            "discount": "Rabatt",
            "inputInPercent": "Angabe in %",
            "specificationInEur": "Angabe in EUR",
            "subtotal": "Zwischensumme",
            "surcharge": "Aufschlag",
            "currentPurchasePrice": "aktueller Einstandspreis",
            "difference": "Differenz",
            "originalPurchasePrice": "Ursprünglicher Einstandspreis",
            "basisForCalculations": "(Basis für Berechnungen)",
            "purchasePrice": "Einstandspreis",
            "entirePriceGroup": "Gesamte Preisgruppe",
            "selectPriceGroup": "Preisgruppe auswählen",
            "showDiscountPDFs": "Rabatt in Angebots- & Auftragsbestätigungs-PDFs anzeigen",
            "costType": "Kostentyp",
            "net": "Netto",
            "gross": "Brutto",
            "percentageInput": "Angabe in %",
            "closeIcon": "Schließen",
            "searchIcon": "Suchen",
            "editEndcustomerAddress": "Endkundenadresse bearbeiten"
        },
        "richtext": {
            "bold": "Fett",
            "italic": "Kursiv",
            "underline": "Unterstrichen",
            "strike": "Durchgestrichen",
            "align": "Ausrichtung",
            "blockquote": "Zitat",
            "code_block": "Code",
            "list": "Liste",
            "color": "Textfarbe",
            "background": "Hintergrundfarbe",
            "image": "Bild einfügen",
            "link": "Link einfügen",
            "clean": "Formatierung entfernen",
            "priceGroupNotModified": "Preisgruppe wurde nicht modifiziert."
        },
        "datepicker": {
            "days": [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ],
            "daysShort": [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ],
            "daysMin": [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ],
            "months": [
                "Januar",
                "Februar",
                "März",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember"
            ],
            "monthsShort": [
                "Jan",
                "Feb",
                "Mär",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez"
            ],
            "today": "Heute",
            "clear": "Löschen",
            "titleFormat": "MM y",
            "format": "dd.mm.yyyy"
        },
        "overlay": {
            "closeOffer": "Angebot schließen",
            "unsavedChanges": "Sie haben ungespeicherte Änderungen, sind Sie sicher, dass Sie das Angebot schließen wollen?"
        },
        "followUp": {
            "removeResubmissionDate": "Wiedervorlagedatum entfernen",
            "setResubmissionDate": "Wiedervorlagedatum setzen",
            "onlyEditResubmissions": "Sie können nur Ihre eigenen Wiedervorlagen bearbeiten."
        },
        "documentTemplate": {
            "template": "Vorlage",
            "offerTemplate": "Angebotsvorlage",
            "orderConfirmationTemplate": "Auftragsbestätigungsvorlage",
            "offerTemplateGotSaved": "Die Angebotsvorlage wurde erfolgreich gespeichert.",
            "filesAllowed": "Es sind nur png und jpg/jpeg Datein erlaubt.",
            "resetToDefault": "Auf Standard zurücksetzen",
            "letterPaper": "Briefpapier",
            "defineLayoutThroughBGImages": "Layout definieren über Hintergrundbild(er)",
            "defineLayoutThroughLogo": "Layout definieren über Logo-Datei",
            "logoPosition": "Logo Positionierung",
            "verticalOrientation": "Vertikale Ausrichtung",
            "horizontalOrientation": "Horizontale Ausrichtung",
            "verticalDisplacement": "Vertikale Verschiebung",
            "horizontalDisplacement": "Horizontale Verschiebung",
            "noLogoAvailable": "Noch kein Logo vorhanden",
            "deleteFile": "Datei löschen",
            "footer": "Fußzeile",
            "noFooterAvailable": "Noch keine Fußzeile vorhanden",
            "firstPage": "Erste Seite",
            "noTemplateAvailable": "Noch keine Vorlage vorhanden",
            "templateNotModified": "Vorlage wurde nicht modifiziert.",
            "subsequentPages": "Folgeseiten",
            "margins": "Seitenränder",
            "top": "Oben",
            "right": "Rechts",
            "bottom": "Unten",
            "left": "Links",
            "forSubsequentPages": "bei Folgeseiten",
            "preview": "Vorschau",
            "mandatoryField": "Pflichtfeld",
            "textContent": "Text-Inhalte",
            "contact": "Ansprechpartner",
            "defaultContactPerson": "Standardmäßig wird der angemeldete Benutzer als Ansprechpartner verwendet, deaktivieren können. Sie dies im Vorgang \"Vorlage bearbeiten\".",
            "displayedContactPerson": "Angezeigter Ansprechpartner im Vorlagenkopf*",
            "eMailOfContact": "E-Mail des Ansprechpartner*",
            "useLoggedInUserAsContact": "Angemeldeten Benutzer als Ansprechpartner verwenden.",
            "telephoneOfContact": "Telefon des Ansprechpartner*",
            "currentLoggedInUser": "Aktuell angemeldeter Benutzer:",
            "emailContent": "E-Mail-Text",
            "emailSubject": "E-Mail Betreff*",
            "subjectLine": "Dies ist ein Betreff",
            "emailBody": "E-Mail-Anschreiben",
            "pdfContent": "PDF-Texte",
            "introductionText": "Einleitungstext",
            "introContent": "Hier steht der Einleitungstext",
            "originalCoverLetter": "Originaler Vorbrief",
            "closingNote": "Abbinder (wird nach der Positionsliste angezeigt)",
            "closingText": "Hier steht der Schlusstext",
            "coverLetter": "Vorbrief",
            "deliveryTimeAndPaymentTerms": "Lieferzeit und Zahlungsbedingungen*",
            "deliveryTime": "Lieferzeit",
            "paymentTermsDescription": "Beschreibung der Zahlungsbedingungen",
            "emailBodyPlaceholder": "Hier steht das Anschreiben",
            "paymentTerms": "Zahlungsbedingungen*",
            "editTemplate": "Vorlage bearbeiten"
        },
        "pcalc": {
            "originType": "Herkunftsart",
            "uvp": "UVP",
            "markupOnPurchasePrice": "Aufschlag zum Einkaufspreis",
            "discountOnRRP": "Rabatt auf den UVP",
            "minMarginOnPurchasePrice": "Mindestmarge auf den Einkaufspreis",
            "addPriceGroup": "Preisgruppe hinzufügen",
            "priceCalculation": "Preiskalkulation",
            "globalPriceCalculation": "Globale Preiskalkulation",
            "priceGroups": "Preisgruppen",
            "updateSuccess": "Die Änderungen wurden erfolgreich aktualisiert.",
            "updateError": "Die Änderungen konnten nicht gespeichert werden.",
            "createSuccess": "Die Preiskalkulation wurde erfolgreich gespeichert.",
            "createError": "Die Preiskalkulation konnte nicht gespeichert werden.",
            "deleteSuccess": "Die Preiskalkulation wurde erfolgreich gelöscht.",
            "deleteError": "Die Preiskalkulation konnte nicht gelöscht werden.",
            "defaultCalculation": "Standardkalkulation",
            "groupNamePlaceholder": "Gruppenname",
            "editGroupName": "Gruppennamen bearbeiten",
            "deleteGroup": "Gruppe löschen",
            "resetTooltip": "Hiermit setzen Sie alle Änderungen zur letzten Speicherung zurück.",
            "reset": "zurücksetzen",
            "invalid": "Ungültig",
            "notModified": "Preisgruppe wurde nicht modifiziert.",
            "validity": "Gültigkeit",
            "daysValidPlaceholder": "z.B. 14",
            "days": "Tage",
            "fixedDates": "Fixtermine",
            "datePlaceholder": "Von",
            "internalComment": "interner Kommentar",
            "commentNote": "(erscheint auf keinem Ausdruck)",
            "commentPlaceholder": "Ihr Kommentar zum Termin",
            "addFixedDate": "Fixtermin hinzufügen",
            "exceptionRule": "Ausnahmeregel",
            "exceptionRules": "Ausnahmeregelungen",
            "youCanIndivualize": "Sie können über die Felder „Attribut“, „Vergleichsoperator“ und „Wert suchen“ (bei „Wert suchen“ mehrfach Auswahl möglich) ihre Kalkulation individualisieren.",
            "processedTopBottom": "Die Regeln werden von oben nach unten abgearbeitet.",
            "filter": "Filter",
            "addExceptionRule": "Ausnahmeregel hinzufügen",
            "exceptionRuleTitle": "Ausnahmeregel Titel",
            "removeFilter": "Filter entfernen",
            "comparisonOperator": "Vergleichsoperator",
            "installationType": "Einbauart",
            "netPrice": "Nettopreis",
            "residentialUnitsCount": "Wohneinheiten",
            "residentialUnitsCountTotal": "Wohneinheiten gesamt",
            "productGroup": "Produktgruppe",
            "modelGroup": "Modellgruppe",
            "equalsExample": "Gleich (z.B., 5 = 5)",
            "notEqualsExample": "Ungleich (z.B., 5 != 3)",
            "greaterExample": "Größer (z.B., 5 > 3)",
            "lessExample": "Kleiner (z.B., 3 < 5)",
            "greaterOrEqualExample": "Größer gleich (z.B., 5 >= 5)",
            "lessOrEqualExample": "Kleiner gleich (z.B., 3 <= 5)",
            "attribute": "Attribut"
        },
        "pcalcGroup": {
            "priceGroup": "Preisgruppe",
            "globalPriceGroup": "globale Preisgruppe",
            "dealerNr": "Händler Nr.",
            "selectPriceGroup": "Preisgruppe auswählen",
            "manualInput": "Manuelle Eingabe",
            "activePriceGroup": "Aktive Preisgruppe",
            "changePriceGroup": "Preisgruppe ändern",
            "applyPriceGroup": "Preisgruppe anwenden",
            "inclusive": "inkl.",
            "vat": "MwSt.",
            "gotApplied": "Preisgruppe wurde erfolgreich angewendet."
        },
        "noOffer": "Kein Angebot",
        "operationsFilter": {
            "all": "alle",
            "taskSent": "Auftragsbestätigung versandt",
            "offerSent": "Angebot versandt",
            "allSources": "Alle Quellen",
            "user_status": "Benutzer Status",
            "internal_status": "Interner Status",
            "undefined": "Alle Stati",
            "inProgress": "in Bearbeitung",
            "created": "Angebot erstellt",
            "outOfferCreated": "Ausgangsangebot erstellt",
            "ordered": "bestellt",
            "open_dealer": "offen",
            "lost_dealer": "verloren",
            "won_dealer": "gewonnen",
            "waitingForResponse_dealer": "Warten auf Antwort",
            "followup_dealer": "Wiedervorlage",
            "locked_dealer": "gesperrt",
            "open_internal": "offen",
            "lost_internal": "verloren",
            "won_internal": "gewonnen",
            "waitingForResponse_internal": "Warten auf Antwort",
            "followup_internal": "Wiedervorlage",
            "locked_internal": "gesperrt",
            "confirmed": "Auftragsbestätigung",
            "inObjectionPeriod": "in Einspruchsfrist",
            "delayed": "Terminverzug",
            "manufactured": "in Fertigung",
            "readyToShip": "im Versand",
            "inShipment": "ausgeliefert",
            "delivered": "zugestellt",
            "canceled": "Storno",
            "applyFilter": "Filter anwenden",
            "resetFilter": "Filter zurücksetzen",
            "agent": "Sachbearbeiter",
            "selectAgent": "Sachbearbeiter auswählen",
            "representative1": "Vertreter 1",
            "selectRepresentative": "Vertreter auswählen",
            "selectModelGroup": "Modellgruppe auswählen",
            "modelGroup": "Modellgruppe",
            "installationType": "Montageart",
            "selectInstallationType": "Montageart auswählen",
            "residentialUnits": "Wohneinheiten",
            "unitPrice": "Einzelpreis",
            "advancedSearch": "Erweiterte Suche",
            "dealerCustomers": "Händlerkunden",
            "enterNumberOrName": "Nummer / Name eingeben",
            "until": "bis",
            "filterTimeRange": "Zeitraum filtern",
            "from": "von",
            "freeSearch": "Freie Suche",
            "origin": "Herkunft",
            "selectOrigin": "Herkunft auswählen",
            "selectStatus": "Status auswählen",
            "status": "Status",
            "filter": "Filter"
        },
        "operationProtocol": {
            "protocolForOffer": "Protokoll zu Angebot {number}",
            "noProtocol": "Dieses Angebot hat noch kein Protokoll.",
            "timestamp": "Zeitpunkt",
            "action": "Vorgang",
            "editor": "Bearbeiter",
            "details": "Details",
            "legend": "Legende",
            "emailSent": "Email versendet",
            "added": "Hinzugefügt",
            "created": "Erstellt",
            "edited": "Bearbeitet",
            "close": "Schließen",
            "protocol": "Protokoll",
            "operationChanges": "Vorgangsveränderungen",
            "fieldName": "Feldname",
            "previousValue": "Vorheriger Wert",
            "currentValue": "Aktueller Wert",
            "noPreviousEntry": "Kein früherer Eintrag",
            "noCurrentEntry": "Kein aktueller Eintrag",
            "creationOrderConfirmation": "Erstellung der Auftragsbestätigung",
            "creationOffer": "Erstellung des Angebots",
            "processingOrderConfirmation": "Bearbeitung der Auftragsbestätigung",
            "processingOffer": "Bearbeitung des Angebots"
        },
        "date": {
            "dateDeleteValidationModal": {
                "question": "Möchten Sie das Datum wirklich entfernen?",
                "cancelButton": "abbrechen",
                "deleteButton": "ja"
            },
            "followUpDeleteValidationModal": {
                "question": "Möchten Sie den Vorgang wirklich von der Merkliste nehmen?",
                "cancelButton": "abbrechen",
                "deleteButton": "ja"
            }
        }
    },
    "config": {
        "open": "Offnen",
        "lost": "Verloren",
        "won": "Gewonnen",
        "locked": "Gesperrt",
        "waitingForResponse": "Wartet auf Antwort",
        "followup": "Wiedervorlage",
        "country": {
            "DE": "Deutschland",
            "AT": "Österreich",
            "SE": "Schweden",
            "LU": "Luxemburg",
            "BE": "Belgien"
        },
        "hints": {
            "placeholderHint": "Sie können folgende Platzhalter einfügen:<br />[Nummer]<br />[Firma]<br />[Vorname]<br />[Nachname]<br />[Bauvorhaben]<br />[Kommission]",
            "imageFormatHint": "Bildformat sollte .jpg oder .png sein. Die optimale Auflösung ist 2480x3508 Pixel. Andere Größen sind möglich, die Anwendung skaliert dann entsprechend. Allerdings kann die Qualität der Darstellung darunter leiden.",
            "imageSimpleFormatHint": "Bildformat sollte .jpg oder .png sein. Die optimale Auflösung für das Logo ist 1240x680 Pixel. Für die Fusszeile ist die optimale Auflösung 2480x240 Pixel bei ca. 3 cm Höhe der Fusszeile. Andere Größen sind möglich, die Anwendung skaliert dann entsprechend. Allerdings kann die Qualität der Darstellung darunter leiden."
        },
        "shippingCompanies": {
            "1003": "DPD",
            "1004": "Spedition Kirchberg/Murr",
            "1005": "Spedition Häring",
            "1006": "Spedition Kunzendorf",
            "1007": "Spedition Franz Lerner GmbH",
            "1010": "Elmar Maurus Logistic",
            "1011": "Spedition Ulmschneider",
            "1012": "DHL Freight GmbH",
            "1013": "Spedition Weckerle",
            "1014": "Spedition H. v. Wirth",
            "1017": "UPS",
            "1023": "Spedition Redemann",
            "1032": "Spedition Dachser",
            "1044": "Transportunternehmen Gert Treitinger",
            "1045": "Spedition Rentschler",
            "1046": "DSV Stuttgart",
            "1047": "TNT",
            "1048": "Spedition Dischinger Ebersbach",
            "1049": "Spedition Atege",
            "1051": "Spedition Schmalz + Schön",
            "1053": "Spedition SCS Stuttgart GmbH",
            "1054": "Spedition L.W.Cretschmar GmbH&Co.KG",
            "1055": "Spedition Trautwein",
            "1056": "Spedition L.Wackler Wwe.Nachf.GmbH",
            "1057": "Spedition Dacotrans Grosskopf GmbH & Co.KG",
            "1058": "Ebenroth - Logistik pur",
            "1059": "HTL-Peter Messner GmbH / Handel-Transport-Logistik",
            "1060": "Kunzendorf Sped. GmbH / Niederlassung Schkeuditz",
            "1061": "Spedition ROHLIG SUUS Logistics SA",
            "1062": "Optimal Kurier",
            "1063": "Heppner Internationale / Spedition GmbH Co. KG",
            "1064": "DACHSER SE Spedition",
            "1065": "Renz Frankreich in FR Spedition",
            "1066": "Renz Polen in PL Spedition",
            "1067": "Inotherm in SI Spedition",
            "1068": "Kühne + Nagel"
        },
        "operationSources": {
            "10": {
                "label": "Back Office"
            },
            "20": {
                "label": "eConfig Pro"
            },
            "30": {
                "label": "eConfig"
            },
            "40": {
                "label": "RIT"
            },
            "50": {
                "label": "eShop"
            },
            "60": {
                "label": "eInfo"
            }
        },
        "installationTypeCodes": {
            "1": "Unterputz/Teilwandmontage",
            "2": "Aufputzmontage",
            "3": "Freistehende Montage, Entnahme vorn",
            "4": "Freistehende Montage, Entnahme hinten",
            "5": "Mauerdurchwurfmontage",
            "6": "Zaunmontage",
            "7": "Türseitenteilmontage, Entnahme hinten",
            "8": "Kontaktsäule",
            "9": "Mauerdurchwurfmontage mit waagerechten Kästen",
            "10": "Einzelmontage",
            "11": "Türseitenteilmontage, Entnahme vorn",
            "12": "Ersatz-Türen/Klappen/Gehäuse",
            "13": "Kundenspezifische Fronten",
            "14": "Mauerdurchwurfmontage (nur Schweiz)"
        },
        "productGroupCodes": {
            "1": "Renz",
            "2": "Startline",
            "3": "Renz Plan"
        },
        "modelGroupCodes": {
            "10": "senkrechte Briefkästen, Entnahme vorn",
            "12": "Türseitenteilbriefkästen, Entnahme hinten",
            "13": "waagerechte Briefkästen, Entnahme vorn",
            "14": "Mauereinbau, Entnahme hinten",
            "15": "Linie Commercial / Linie Privat",
            "16": "Sprech/Klingelanlagen",
            "17": "Zaunbriefkästen/Einzelkomponenten",
            "20": "Aufbewahrungsanlagen",
            "21": "Postverteileranlagen Durchwurf",
            "22": "Postverteileranlagen Frontlader",
            "23": "Brief- u. Paketkastenanlagen CLASSIC",
            "25": "Startline senkrechte Briefkästen, Entnahme vorn",
            "26": "Startline waagerechte Briefkästen, Entnahme vorn",
            "27": "Startline Türseitenteilbriefkästen, Entnahme hinten",
            "29": "Budget Türseitenteilbriefkästen, Entnahme hinten",
            "30": "Mitteilungskästen",
            "40": "Autohauskästen",
            "41": "Apothekenkästen",
            "42": "Sicherheitsbriefkästen",
            "43": "Tag-/Nachtbriefkästen",
            "50": "Export-Modelle Schweiz",
            "58": "Budget waagrechte Briefkästen, Entnahme vorn",
            "60": "RENZ PLAN senkrechte Briefkästen, Entnahme vorn",
            "61": "RENZ PLAN waagerechte Briefkästen, Entnahme vorn",
            "62": "RENZ PLAN senkrechte Briefkästen, Entnahme hinten",
            "63": "RENZ PLAN Stelen",
            "64": "RENZ PLAN S Türseitenteilbriefkästen",
            "65": "RENZ PLAN S Mauereinbau, Entnahme hinten",
            "67": "RENZ PLAN S, senkrechte Briefkästen, Entnahme vorn",
            "68": "RENZ PLAN SL, waagerechte Briefkästen, Schweiz",
            "78": "MEFA",
            "90": "Ersatzteile mit Gravur",
            "97": "Ersatzteile"
        }
    },
    "general": {
        "foldIn": "Einklappen",
        "removeExceptionFilter": "Filter entfernen. Hinweis: Eine Ausnahmeregel ohne Filter wird beim Speichern automatisch gelöscht.",
        "exceptionWithoutFilter": "Ausnahmeregelungen ohne Filter werden automatisch entfernt. Speichern sie Universale Kalkulationen außerhalb der Ausnahmeregelungen.",
        "foldOut": "Ausklappen",
        "logoutWarning": "Sie werden in {logoutInMinutes} Minute{plural} ausgeloggt, wenn Sie keine Aktionen durchführen.",
        "errorOccurred": "Es ist ein Fehlr aufgetreten! Bitte lade Sie die Seite neu und versuchen es später nocheinmal.",
        "fullText": "Vollständiger Text",
        "removeFilter": "Filter entfernen",
        "warning": "Warnung",
        "pushDown": "Nach unten schieben",
        "pushUp": "Nach oben schieben",
        "restore": "Wiederherstellen",
        "ok": "OK",
        "yes": "Ja",
        "no": "Nein",
        "send": "Absenden",
        "cancel": "Abbrechen",
        "save": "Speichern",
        "close": "Schließen",
        "back": "Zurück",
        "next": "Weiter",
        "delete": "Löschen",
        "edit": "Bearbeiten",
        "noted": "Gemerkt",
        "note": "Merken",
        "beeingLoaded": "Wird geladen...",
        "pleaseWait": "Bitte warten...",
        "preview": "Vorschau",
        "logo": "Logo",
        "selectFile": "Datei auswählen",
        "legend": "Legende",
        "eMailAddress": "E-Mail Adresse",
        "telephone": "Telefonnummer",
        "webAddress": "Web-Adresse",
        "add": "Hinzufügen",
        "mr": "Herr",
        "mrs": "Frau",
        "others": "Sonstige",
        "planned": "geplant",
        "origin": "Herkunft",
        "positionShortName": "Pos.",
        "dealerDataNotFound": "Händlerdaten nicht gefunden",
        "commission": "Kommission",
        "offer": "Angebot",
        "order": "Auftrag",
        "actions": "Aktionen",
        "loadMore": "... mehr laden",
        "type": "Typ",
        "selectType": "Typ auswählen",
        "pageNotFound": "Seite nicht gefunden<br /><br />Pfad: {path}",
        "mandatoryField": "Pflichtfeld",
        "dataStored": "Daten gespeichert",
        "description": "Beschreibung",
        "and": "und",
        "rule": "Regel",
        "units": "Einheiten",
        "lookForValue": "Wert suchen",
        "copy": "Kopieren",
        "share": "Teilen",
        "entrance": "Eingang",
        "exit": "Ausgang",
        "reset": "⟳ zurücksetzen",
        "apply": "Anwenden",
        "email": "E-Mail",
        "phone": "Tel.",
        "duplicate": "Duplizieren",
        "accessKeyCreated": "Zugangsschlüssel wurde erstellt.",
        "accessKeyDeleted": "Zugangsschlüssel wurde entfernt.",
        "newVersionAvailable": "Eine neue Version der Software ist verfügbar.<br>Die Seite wird neu geladen.",
        "incompleteInfo": "Es liegen noch nicht alle<br>Informationen vor.<br><br>Bitte versuchen Sie es später erneut."
    }
}
